function termUidToLabel(contentType: string): string {
  switch (contentType) {
    case 'courses':
      return 'Course';
    case 'explainers':
      return 'Explainer';
    case 'change_logs':
      return 'Change Log';
    case 'coding':
      return 'Coding';
    case 'webinar':
      return 'Webinar';
    case 'podcast':
      return 'Podcast';
    default:
      return contentType ? contentType.charAt(0).toUpperCase() + contentType.slice(1) : '';
  }
}

export default function getContentType(taxonomies: any[], returnCT: string) {
  const matchedTaxonomy = taxonomies?.find(
    (t: any) => (t.taxonomy_uid || t.parent_uid) === returnCT
  );
  const termUid = matchedTaxonomy?.term_uid ?? matchedTaxonomy?.uid ?? '';
  const contentType = typeof termUid === 'string' ? termUid : '';
  return termUidToLabel(contentType);
}

/** Returns all content_type labels from taxonomies as comma-separated string (e.g. "Coding, Explainer") */
export function getContentTypeLabels(taxonomies: any[]): string {
  const contentTypes = taxonomies?.filter(
    (t: any) => (t.taxonomy_uid || t.parent_uid) === 'content_type'
  ) ?? [];
  const labels = contentTypes
    .map((t: any) => {
      const uid = t.term_uid ?? t.uid ?? '';
      return typeof uid === 'string' ? termUidToLabel(uid) : '';
    })
    .filter(Boolean);
  return [...new Set(labels)].join(', ');
}
